import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Card,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TablePagination,
  TableRow,
  Paper,
  Button,
  TableHead,
  IconButton,
  Switch,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import { Link } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { API_ENDPOINTS } from "../../../config/api";
import { useAuth } from "../../../context/AuthContext";

const API_URL = API_ENDPOINTS.DELIVERY_TERMS;

const DeliveryTermsListContent = () => {
  const [deliveryTerms, setdeliveryTerms] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const { user } = useAuth();
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [deleteDialog, setDeleteDialog] = useState({
    open: false,
    id: null,
    name: "",
  });

  useEffect(() => {
    fetchdeliveryTerms();
  }, []);

  const fetchdeliveryTerms = async () => {
    try {
      const response = await axios.get(API_URL.BASE);
      const data = response.data;
      let deliveryTermsArray = [];
      if (Array.isArray(data)) {
        deliveryTermsArray = data;
      } else if (data && Array.isArray(data.deliveryTerms)) {
        deliveryTermsArray = data.deliveryTerms;
      }
      setdeliveryTerms(deliveryTermsArray);
    } catch (error) {
      console.error("Error fetching delivery terms:", error);
      setdeliveryTerms([]);
    }
  };

  const handleDeleteClick = (id, name) => {
    setDeleteDialog({
      open: true,
      id,
      name,
    });
  };

  const handleDeleteConfirm = async () => {
    try {
      await axios.delete(API_URL.DELETE(deleteDialog.id));
      setdeliveryTerms((prevdeliveryTerms) => 
        prevdeliveryTerms.filter((deliveryTerm) => deliveryTerm.id !== deleteDialog.id)
      );
      setSnackbar({
        open: true,
        message: "Delivery term deleted successfully",
        severity: "success",
      });
    } catch (error) {
      console.error("Error deleting delivery term:", error);
      setSnackbar({
        open: true,
        message: error.response?.data?.message || "Failed to delete delivery term",
        severity: "error",
      });
    } finally {
      setDeleteDialog({
        open: false,
        id: null,
        name: "",
      });
    }
  };

  const handleDeleteCancel = () => {
    setDeleteDialog({
      open: false,
      id: null,
      name: "",
    });
  };

  const handleTogglePublish = async (id, currentStatus) => {
    try {
      await axios.put(API_URL.EDIT(id), { publish: !currentStatus });
      setdeliveryTerms((prevdeliveryTerms) =>
        prevdeliveryTerms.map((deliveryTerm) =>
          deliveryTerm.id === id ? { ...deliveryTerm, publish: !currentStatus } : deliveryTerm
        )
      );
      setSnackbar({
        open: true,
        message: `Delivery term ${!currentStatus ? "published" : "unpublished"} successfully`,
        severity: "success",
      });
    } catch (error) {
      console.error("Error updating publish status:", error);
      setSnackbar({
        open: true,
        message: error.response?.data?.message || "Failed to update publish status",
        severity: "error",
      });
    }
  };
  

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const filtereddeliveryTerms = Array.isArray(deliveryTerms)
    ? deliveryTerms.filter((deliveryTerm) =>
        deliveryTerm.name.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : [];

  return (
    <Card sx={{ boxShadow: "none", borderRadius: "7px", mb: "25px", padding: "25px" }}>
      {/* <NavList /> */}
      <Box>
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: "25px" }}>
          <input
            type="text"
            placeholder="Search Delivery Terms..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ padding: "8px", width: "200px", borderRadius: "5px", border: "1px solid #ccc" }}
          />
          {user.permissions.includes("add-deliveryTerms") && (  
            <Link to="/ecommerce/create-delivery-term">
              <Button variant="outlined" color="primary">
                <AddIcon /> Add New delivery Term
              </Button>
            </Link>
          )}
        </Box>

        <TableContainer className="custom-table" component={Paper}>
          <Table sx={{ minWidth: 1000 }} aria-label="delivery Terms Table">    
            <TableHead>
              <TableRow>
                <TableCell>S.No</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Publish</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filtereddeliveryTerms
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((deliveryTerm, index) => (
                  <TableRow key={deliveryTerm.id}>
                    <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                    <TableCell>{deliveryTerm.name}</TableCell>
                    <TableCell>
                      <Switch
                        checked={deliveryTerm.publish}
                        onChange={() => handleTogglePublish(deliveryTerm.id, deliveryTerm.publish)}
                        color="success"
                      />
                    </TableCell>
                    <TableCell>
                      {/* {user.permissions.includes("view-deliveryTerms") && (
                        <Link to={`/ecommerce/delivery-terms-list/details/${deliveryTerm.id}`}>
                          <IconButton color="info">
                            <VisibilityIcon />
                          </IconButton>
                        </Link>
                      )} */}
                      {user.permissions.includes("edit-deliveryTerms") && (
                        <Link to={`/ecommerce/edit-delivery-term/${deliveryTerm.id}`}>
                          <IconButton color="primary">
                            <EditIcon />
                          </IconButton>
                        </Link>
                      )}
                      {user.permissions.includes("delete-deliveryTerms") && (
                        <IconButton 
                          color="error" 
                          onClick={() => handleDeleteClick(deliveryTerm.id, deliveryTerm.name)}
                        >
                          <DeleteIcon />
                        </IconButton>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                  count={filtereddeliveryTerms.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={(event, newPage) => setPage(newPage)}
                  onRowsPerPageChange={(event) => {
                    setRowsPerPage(parseInt(event.target.value, 10));
                    setPage(0);
                  }}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </Box>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={deleteDialog.open}
        onClose={handleDeleteCancel}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
      >
        <DialogTitle id="delete-dialog-title">
          Delete Delivery Term
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="delete-dialog-description">
            Are you sure you want to delete the delivery term "{deleteDialog.name}"? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCancel} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDeleteConfirm} color="error" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: "100%" }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Card>
  );
};

export default DeliveryTermsListContent;